import { Component, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'commit-list',
  template: require('./commit-list.directive.html'),
})
export class CommitListComponent {
  @Input() commits: any[];

  constructor(private stateService: StateService) {
  }

  goToUserHome(unixName: string) {
    this.stateService.go('home.user.userhome', { unixName: unixName });
  }
}

